import useSWR from 'swr';
import Auth from '../../../Auth';
import { useEffect, useState } from 'react';
import usePublicMode from '../../../hooks/usePublicMode';

export default function usePluginsCategories({ includeOther = true } = {}) {
  const [pluginCategories, setPluginCategories] = useState(null);
  const { urlPrefixApiPlugins } = usePublicMode();

  const { data, error, isLoading } = useSWR(`${urlPrefixApiPlugins}/api/plugins/categories/list`, Auth.fetchWithIdToken);

  useEffect(() => {
    if (data && !isLoading) {
      let categories = data.categories;
      if (!includeOther) {
        categories = categories.filter((category) => category.name !== "Other");
      }
      setPluginCategories(categories);
    }
  }, [data, isLoading]);

  return { pluginCategories, isLoading, error };
}
